var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.running)?_c('div',{class:{danger: _vm.critical},style:({ background: 'linear-gradient(\n'+
'          rgba(0, 0, 0, 0.28), \n'+
'          rgba(0, 0, 0, 0.42)\n'+
'        ),url(' + require('@/assets/images/about_bg.jpg') + ')' }),attrs:{"id":"count-down"}},[_c('span',[_c('span',[_vm._v(_vm._s(_vm.min))]),_vm._v(":"),_c('span',[_vm._v(_vm._s(_vm.sec))])]),_c('span',{staticStyle:{"font-size":"1rem"}},[_vm._v("verbleibende Zeit")])]):_c('div',[_vm._v(" over ")])}
var staticRenderFns = []

export { render, staticRenderFns }